import script from "./backgroundRecharge.vue?vue&type=script&setup=true&lang=ts"
export * from "./backgroundRecharge.vue?vue&type=script&setup=true&lang=ts"

import "./backgroundRecharge.vue?vue&type=style&index=0&id=4a29a850&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a29a850"]])

export default __exports__